import { MuiAvatar } from './avatar';
import { MuiButton } from './button';
import { MuiInputBase } from './inputBase';
import { MuiLink } from './link';

export const components = {
  MuiAvatar,
  MuiButton,
  MuiInputBase,
  MuiLink,
};
